import React from 'react'
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined'
import moment from 'moment'
import { Box } from '@mui/material'
import { colors } from '@resiliatech/birdsong'
import { DatePicker } from '../../../../../SharedComponents/DatePicker/DatePicker'
import {
  ISO_8601_DATE_FORMAT,
  TASK_DATE_FORMAT,
} from '../../../ImpactReportDashboard/utils'
import { OnUpdateOptions } from '../types'
import { dateInputStyles, ErrorMessage, errStyles } from './TaskModalV2.styled'

type UntilDateInputProps = {
  onUpdateOptions: OnUpdateOptions
  startDate: string | null | undefined
  endDate: string | null | undefined
  error: string
}

export const UntilDateInput = ({
  onUpdateOptions,
  startDate,
  endDate,
  error,
}: UntilDateInputProps) => {
  const styles = { ...dateInputStyles, ...(error ? errStyles : {}) }

  return (
    <Box sx={{ flex: '1' }}>
      <DatePicker
        props={{
          disabled: !startDate,
          slots: { openPickerIcon: InsertInvitationOutlinedIcon },
          required: true,
        }}
        slotProps={{
          openPickerIcon: { sx: { color: colors.interactive.primaryEnabled } },
        }}
        date={
          endDate
            ? moment.utc(endDate, ISO_8601_DATE_FORMAT).format(TASK_DATE_FORMAT)
            : null
        }
        label='Until*'
        onDateSelected={(date) => {
          onUpdateOptions({
            key: 'endDate',
            value: date ? moment.utc(date).format(TASK_DATE_FORMAT) : null,
          })
        }}
        styles={styles}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Box>
  )
}
